export default __webpack_public_path__ + "static/media/askimdeniz2.c88df36e.jpg";